<template>
  <div class="content">
    <div class="loginSuccess">
      登录成功
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      //
      ticket: "",
      id: ""
    };
  },
  created() {
    //
  },
  mounted() {
    //
    var dom = document.querySelector('.tips-box');
    dom.style.display = "none"
  },
  methods: {
    //
    setTicket() {
      this.$rqt.tysfrz_reviceUrl({
        id, data: { ticket: this.ticket }
      }).then(res => {
        console.log(res);

      })
    }
  },
};
</script>
<style scoped lang="scss">
.content {
  width: 100%;
  height: 100vh;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loginSuccess {
  font-size: 25rem;
}
</style>